module.exports = __webpack_public_path__ + "static/bi-8b7900e0e63fc5103b7847aa98cb9487.jpg";